export default __webpack_public_path__ + "static/media/banner-mobile-bg-darkblue-template.555db99e.svg";